import React from "react";
import Box from "@mui/material/Box";
import AdminSideNav from "../../app/nav/AdminSideNav";

const AdminMainLayout = React.memo(
  () => {
    return (
      <Box>
        <AdminSideNav
        />
      </Box>
    );
  }
);

export default AdminMainLayout;
